import React from 'react';
import SubjectPage from '../subjects/SubjectPage';

function NcertBooks() {

    const pageTitleText = "NEET NCERT Books ";

  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="ncertbook" 
        type="ncertbook"
      />

    </>
  );
}

export default NcertBooks;